// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import "../../style/contactPage/contactpage.scss";
// import img1 from "../../assets/pexels-pixabay-326055.jpg";
// import img2 from "../../assets/book-1.jpeg";
// import img3 from "../../assets/book-2.jpg";
// import img4 from "../../assets/book-3.jpeg";
// import Header from "../work/header";

// const About = () => {
//   return (
//     <div className="about-section py-5">
//       <Header />
//       <Container>
//         {/* About */}
//         <Row className="mb-5 office-m-t">
//           <Col md={3}>
//             <h4>About</h4>
//           </Col>
//           <Col md={9}>
//             <p>
//               SE-ARCH, THE STUDIO FOR ENVIRONMENT & ARCHITECTURE is dedicated to
//               providing comprehensive vision of spaces, which makes them
//               instantly liveable.
//             </p>
//             <p>
//               A partnership founded by Jayshree & Kapil Bhalla in 1990, SE-ARCH
//               has earned a reputation of exceptional, innovative design
//               strategies that result in a highly personalized service.
//             </p>
//             <p>
//               The side-army of services ensures a multidisciplinary approach and
//               guarantees exceptional quality along with all-round
//               sustainability.
//             </p>
//           </Col>
//         </Row>

//         {/* Team */}
//         <Row className="mb-5">
//           <Col md={3}>
//             <h4>Team</h4>
//           </Col>
//           <Col md={9}>
//             <p>
//               SE-ARCH is equipped with a team of energetic leaders from
//               well-established education backgrounds that showcase a multitude
//               of talent and genuine creativity...
//             </p>
//             <img src="../../assets/pexels-pixabay-326055.jpg" alt="Team" className="img-fluid mt-3" />
//           </Col>
//         </Row>

//         {/* Leadership */}
//         <Row className="mb-5">
//           <Col md={3}>
//             <h4>Leadership</h4>
//           </Col>
//           <Col md={9}>
//             <Row>
//               <Col
//                 md={6}
//                 onClick={() => window.open("/portfolio/kapil-bhalla", "_blank")}
//                 style={{ cursor: "pointer" }}
//               >
//                 <h6>Kapil Bhalla</h6>
//                 <p>Founder and Principal Architect</p>
//               </Col>

//             </Row>
//           </Col>
//         </Row>

//         {/* Accolades */}
//         <Row>
//           <Col md={12}>
//             <h4>Accolades</h4>

//             <div className="timeline">
//               <Row className="mb-3">
//                 <Col md={3} className="timeline-year">
//                   <strong>2014</strong>
//                 </Col>
//                 <Col md={9}>
//                   <p>
//                     <span className="design-font">
//                       Design Excellence in Architecture and Interior Design
//                     </span>
//                     <br />
//                     Society Interiors Design Awards
//                   </p>
//                   <p>
//                     <span className="design-font">
//                       {" "}
//                       National Winner in design Coffee Shop & Bar/Pub categories
//                     </span>
//                     <br />
//                     Society Interiors Design Awards
//                   </p>
//                 </Col>
//               </Row>

//               <Row className="mb-3">
//                 <Col md={3} className="timeline-year">
//                   <strong>2005</strong>
//                 </Col>
//                 <Col md={9}>
//                   <p>
//                     <span className="design-font">
//                       Design Excellence in Architecture and Interior Design
//                     </span>
//                     <br />
//                     Society Interiors Design Awards
//                   </p>
//                 </Col>
//               </Row>

//               <Row className="mb-3">
//                 <Col md={3} className="timeline-year">
//                   <strong>1996</strong>
//                 </Col>
//                 <Col md={9}>
//                   <p>
//                     <span className="design-font">
//                       {" "}
//                       Design Excellence in Architecture and Interior Design
//                     </span>
//                     <br />
//                     Society Interiors Design Awards
//                   </p>
//                 </Col>
//               </Row>

//               <Row className="mb-3">
//                 <Col md={3} className="timeline-year">
//                   <strong>1994</strong>
//                 </Col>
//                 <Col md={9}>
//                   <p>
//                     <span className="design-font">
//                       Design Excellence in Architecture and Interior Design{" "}
//                     </span>
//                     <br />
//                     Society Interiors Design Awards
//                   </p>
//                 </Col>
//               </Row>
//             </div>
//           </Col>
//         </Row>
//         <h3 className="mt-5">Publications</h3>
//         <Row>
//           <Col md={4} className="mb-4">
//             <img
//               src={img2}
//               alt="Publication 1"
//               className="img-fluid mb-2 publication-img"
//             />
//             <h5>Indian Architect & Builder</h5>
//             <p>April - 2005</p>
//           </Col>
//           <Col md={4} className="mb-4">
//             <img
//               src={img3}
//               alt="Publication 2"
//               className="img-fluid mb-2 publication-img"
//             />
//             <h5>Indian Architect & Builder</h5>
//             <p>April - 2005</p>
//           </Col>
//           <Col md={4} className="mb-4">
//             <img
//               src={img4}
//               alt="Publication 3"
//               className="img-fluid mb-2 publication-img"
//             />
//             <h5>Indian Architect & Builder</h5>
//             <p>April - 2005</p>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };

// export default About;

import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../style/contactPage/contactpage.scss";
import img1 from "../../assets/pexels-pixabay-326055.jpg";
import axios from "axios";
import Header from "../work/header";

const About = () => {
  //   const [officeData, setOfficeData] = useState(null);

  //   useEffect(() => {
  //     const fetchData = async () => {
  //       try {
  //         const response = await axios.get(
  //           "https://infoglans.com/search/wp-json/wp/v2/pages/156"
  //         );
  //         const data = response.data;
  //         console.log("API Response:", data);
  //         setOfficeData(data.acf.office);
  //       } catch (error) {
  //         console.error("Error fetching data:", error);
  //       }
  //     };

  //     fetchData();
  //   }, []);

  //   if (!officeData) {
  //     return <p>Loading...</p>;
  //   }

  //   console.log("officedata", officeData);

  const [officeData, setOfficeData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMediaUrl = async (id) => {
      try {
        const response = await axios.get(
          `https://infoglans.com/search/wp-json/wp/v2/media/${id}`
        );
        console.log("response.data", response.data);

        return response.data.source_url; // actual image URL
      } catch (error) {
        console.error("Error fetching media:", error);
        return null;
      }
    };

    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://infoglans.com/search/wp-json/wp/v2/pages/156"
        );
        const data = response.data;
        let publications = data.acf.office.publications || [];

        // Fetch all media URLs for the publication images
        const updatedPublications = await Promise.all(
          publications.map(async (pub) => {
            const imageUrl = await fetchMediaUrl(pub.publications_img);
            return {
              ...pub,
              publications_img_url: imageUrl,
            };
          })
        );

        const officeImgUrl = await fetchMediaUrl(data.acf.office.office_img);

        // Set modified data with image URLs
        setOfficeData({
          ...data.acf.office,
          office_img_url: officeImgUrl,
          publications: updatedPublications,
        });
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  console.log("officedata", officeData);

  if (loading || !officeData) {
    return <p>Loading...</p>;
  }

  return (
    <div className="about-section py-5">
      <Header />
      <Container>
        {/* About */}
        <Row className="mb-5 office-m-t">
          <Col md={3}>
            <h4>{officeData.office_title}</h4>
          </Col>
          <Col md={9}>
            <div dangerouslySetInnerHTML={{ __html: officeData.office_desc }} />
          </Col>
        </Row>

        {/* Team */}
        <Row className="mb-5">
          <Col md={3}>
            <h4>{officeData.team_titel}</h4>
          </Col>
          <Col md={9}>
            <div dangerouslySetInnerHTML={{ __html: officeData.team_desc }} />
            </Col>
            </Row>
            <Row>
            {officeData.office_img && (
              //   <img src={img1} alt="Office" className="img-fluid mt-3" />
              <img
                src={officeData.office_img_url}
                alt="Office"
                className="img-fluid mt-3"
              />
            )}
          </Row>
       

        {/* Leadership */}
        <Row
          className="mb-2 office-12"
          onClick={() => window.open("/portfolio/kapil-bhalla", "_blank")}
          style={{ cursor: "pointer" }}
        >
          <Col md={3}>
            <h4>Leadership</h4>
          </Col>
          </Row>
          <Row className="mt-0 pt-0 mb-5">
          <Col md={6}>
            <h6>{officeData.kapil_bhalla_name}</h6>
            <p>{officeData.kapil_bhalla_title}</p>
            <p>{officeData.kapil_bhalla_desc}</p>
          </Col>
          <Col md={6}>
            <h6>Jayshree Badra Bhalla</h6>
            <p>Co-Founder and Principal Architect</p>
            <p>{officeData.kapil_bhalla_desc}</p>
          </Col>
        </Row>

        {/* Accolades */}
        <Row className="mt-5">
          <Col md={12}>
            <h4>Accolades</h4>
            {officeData.accolades?.map((item, index) => (
              <Row key={index} className="mb-3 mt-3">
                <Col md={3}>
                  <strong >{item.accolades_title}</strong>
                </Col>
                <Col md={9}>
                  <p className="font-h-w-2">{item.accolades_sub_title}</p>
                  <p>{item.accolades_desc}</p>
                </Col>
              </Row>
            ))}
          </Col>
        </Row>

        {/* Publications */}
        <h3 className="mt-5">Publications</h3>
        <Row>
          {officeData.publications?.map((pub, index) => (
            <Col md={4} className="mb-4" key={index}>
              {pub.publications_img && (
                <img
                  src={pub.publications_img_url}
                  alt="Publication"
                  className="img-fluid mb-2 publication-img"
                />
              )}
              <h5>{pub.publications_title}</h5>
              <p>{pub.publications_desc}</p>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default About;
